document.addEventListener("DOMContentLoaded", function() {
    const shirtsMenu = document.querySelector('.shirts');
    const dropdown = document.querySelector('.dropdown');
    const logoArea = document.querySelector('.pageheader'); // The div where the dropdown should close when mouse leaves
    const otherMenuItems = document.querySelectorAll('.custom-nav li:not(.shirts_li)'); // Other menu items (li elements)
    let timeout;

    if (shirtsMenu && dropdown && logoArea) {
        // Show dropdown when hovering over the Shirts menu
        shirtsMenu.addEventListener('mouseover', () => {
            clearTimeout(timeout);
            dropdown.style.display = 'block';
        });

        // Keep the dropdown open when hovering over it
        dropdown.addEventListener('mouseover', () => {
            clearTimeout(timeout);
            dropdown.style.display = 'block';
        });

        // Close the dropdown when the mouse leaves the dropdown area or logo area
        logoArea.addEventListener('mouseleave', () => {
            timeout = setTimeout(() => {
                dropdown.style.display = 'none';
            }, 200);
        });

        // Close the dropdown when hovering over any other menu item
        otherMenuItems.forEach(item => {
            item.addEventListener('mouseover', () => {
                dropdown.style.display = 'none';
            });
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const tshirtMenu = document.querySelector('.tshirt-li');
    const dropdownTshirt = document.querySelector('.dropdown-tshirt');
    const logoArea = document.querySelector('.pageheader'); // The div to close the dropdown
    const otherMenuItems = document.querySelectorAll('.custom-nav li:not(.tshirt-li)'); // Other menu items (li elements)
    let timeout;

    if (tshirtMenu && dropdownTshirt && logoArea) {
        // Show dropdown when hovering over the T-shirts menu
        tshirtMenu.addEventListener('mouseover', () => {
            clearTimeout(timeout);
            dropdownTshirt.style.display = 'flex';
        });

        // Keep the dropdown open when hovering over it
        dropdownTshirt.addEventListener('mouseover', () => {
            clearTimeout(timeout);
            dropdownTshirt.style.display = 'flex';
        });

        // Close the dropdown when the mouse leaves the dropdown area or logo area
        logoArea.addEventListener('mouseleave', () => {
            timeout = setTimeout(() => {
                dropdownTshirt.style.display = 'none';
            }, 200);
        });

        // Close the dropdown when hovering over any other menu item
        otherMenuItems.forEach(item => {
            item.addEventListener('mouseover', () => {
                dropdownTshirt.style.display = 'none';
            });
        });
    }
});

// Menu link active when open

//   document.addEventListener('DOMContentLoaded', () => {
//     const navLinks = document.querySelectorAll('.custom-nav li a');

//     // Function to set active class based on current URL
//     function setActiveClass() {
//       const currentPath = window.location.pathname;
//       navLinks.forEach(link => {
//         const href = link.getAttribute('href');
//         if (currentPath === href) {
//           link.classList.add('active');
//         } else {
//           link.classList.remove('active');
//         }
//       });
//     }

//     navLinks.forEach(link => {
//       link.addEventListener('click', function() {
//         // Remove active class from all links
//         navLinks.forEach(navLink => {
//           navLink.classList.remove('active');
//         });

//         // Add active class to the clicked link
//         this.classList.add('active');
//       });
//     });

//     // Set active class on page load
//     setActiveClass(.custom-nav li a);
//   });
// Menu link active when open

// document.addEventListener('DOMContentLoaded', function() {
//   const menuItems = document.querySelectorAll('.shirts_li');

//   menuItems.forEach(item => {
//     item.addEventListener('click', function() {
//       // Remove active class from all menu items
//       menuItems.forEach(i => i.classList.remove('active'));
      
//       // Add active class to the clicked item
//       item.classList.add('active');
      
//       // Store the active item in localStorage
//       localStorage.setItem('activeMenuItem', item.id);
//     });
//   });

//   // On page load, set the active item from localStorage
//   const activeItem = localStorage.getItem('activeMenuItem');
//   if (activeItem) {
//     document.getElementById(activeItem).classList.add('active');
//   }
// });


/*New hover js*/
// Get all navigation links
const navLinks = document.querySelectorAll('.custom-nav li a');

// Get the current URL path (without domain and query parameters)
const currentPath = window.location.pathname;

// Loop through each navigation link
navLinks.forEach(link => {
    // Check if the link's href matches the current path
    if (link.getAttribute('href') === currentPath) {
        // Add the active class to the matching link
        link.classList.add('active');
    } else {
        // Remove the active class from non-matching links
        link.classList.remove('active');
    }
});


var swiper = new Swiper('.swiper-container', {
  loop: false,
  autoplay: false,
  // Additional configuration
});

